// import './wdyr'
import './i18n.jsx'
import 'window.jsx'

import React      from 'react'
import ReactDOM   from 'react-dom/client'

import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter, Navigate, Route, Routes }  from 'react-router-dom'
import { GlobalStyle }    from 'styles/GlobalStyle'

import { Boot } from 'main/Boot'
import { Head } from 'main/Head'

import { ProjectData_Mono } from 'main/ProjectData_mono'
import { ProjectData_Poly } from 'main/ProjectData_poly'

import { PreloadFrames_Poly }     from 'main/Preloading/PreloadFrames_poly'
import { PreloadFrames_Mono }     from 'main/Preloading/PreloadFrames_mono'
import { PreloadFrames_Tiny }     from 'main/Preloading/PreloadFrames_tiny'
import { PreloadSvg_Overlays }    from 'main/Preloading/PreloadSvg_Overlays'
import { GetIP }                  from 'main/GetIP'

import { Language } from 'main/Language'

import { PreloadCompares } from 'main/PreloadCompares'
import { App }             from './App'
import { BackgroundUnitLoading } from 'main/Preloading/BackgroundUnitLoading.jsx'
import { BackgroundGallaryLoading } from 'main/Preloading/BackgroundGallaryLoading.jsx'
import { PreloadFramesLowerQuality_Mono } from 'main/Preloading/PreloadFramesLowerQuality_mono.jsx'
import { ErrorBoundary } from 'ErrorBoundary.jsx'
import { Maintenance } from 'components/ErrorsPage/Maintenance.jsx'
import AppThemeProvider from 'theme/ThemeProvider.jsx'
import { current_language, isInActive, isMaintence } from 'state/store.global.jsx'
import { useAtom, useGet } from 'state/jotai.jsx'

import { InactivePage } from 'components/ErrorsPage/InactivePage.jsx'

const strict = false

const Main = () => {
  const language = useAtom(current_language)[0];
      
  const isMaintencePage = useGet(isMaintence)
  const isInActivePage = useGet(isInActive)

  // If any mode is active, redirect to "that particular sign page"
  if (isMaintencePage || isInActivePage) {

    const pageRoutes = {
      isMaintencePage: 'under-maintenance',
      isInActivePage: 'inactive'
    }

    const pageComponent = {
      'under-maintenance': <Maintenance />,
      'inactive': <InactivePage />
    }

    const currentRoute = pageRoutes[isMaintencePage ? 'isMaintencePage' : '' ] || pageRoutes[isInActivePage ? 'isInActivePage' : '']

    return <BrowserRouter>
      <AppThemeProvider>
        <Language />
        <GlobalStyle />
      <Routes>
        <Route path="/" element={<Navigate to={`/${language}/${currentRoute}`} replace />} />
        <Route path={`/:lang/${currentRoute}`} element={ pageComponent[currentRoute] } />
      </Routes>
      </AppThemeProvider>
    </BrowserRouter>;
  }

  return (
    <HelmetProvider>
      <BrowserRouter>
      <AppThemeProvider>
      <ErrorBoundary fallback={<Maintenance />}>
      <Head />
      <Boot />
  
      <GetIP/>
      <ProjectData_Mono />
      <ProjectData_Poly />
      <PreloadFramesLowerQuality_Mono />
      <PreloadFrames_Mono />
      <PreloadFrames_Poly />
      <PreloadFrames_Tiny />
  
      <PreloadSvg_Overlays />
  
      <PreloadCompares />
        <Language />
        <GlobalStyle/>
        <App />
        <BackgroundUnitLoading />
        <BackgroundGallaryLoading />
        </ErrorBoundary>
        </AppThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  )
}

ReactDOM.createRoot(
  document.getElementById('root')
).render(
  strict 
  ? <React.StrictMode>
      <Main />
    </React.StrictMode> 
  :  <Main />
)